export class IrSubJudiModel {

    constructor(
        public mmReferencia?: string,
        public vlFracao?: number,
        public vlIrrf?: number,
        public vlSindsep?: number
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/ir-sub-judi.model.ts